import React, { Component } from "react";
import PropTypes from "prop-types";
import { IconButton, AppBar, Toolbar, Typography, Tooltip } from "material-ui";
import {
    FormatClear as FormatClearIcon,
    Undo as UndoIcon,
    Redo as RedoIcon
} from "material-ui-icons";
import { withStylesAndTranslation } from "../utils/container";

const styleSheet = theme => ({
    button: {
        margin: theme.spacing.unit
    },
    appBar: {
        width: "100%",
        margin: theme.spacing.unit
    },
    "@media (min-width: 600px)": {
        appBar: {
            marginLeft: 0
        }
    },
    flex: {
        flex: 1
    }
});

class CorrectionToolbar extends Component {
    static propTypes = {
        onUndo: PropTypes.func.isRequired,
        onRedo: PropTypes.func.isRequired,
        onRevertSelection: PropTypes.func.isRequired,
        classes: PropTypes.object.isRequired,
        title: PropTypes.string.isRequired,
        t: PropTypes.func.isRequired
    };

    render() {
        const {
            classes,
            onUndo,
            onRedo,
            onRevertSelection,
            title,
            t
        } = this.props;

        return (
            <AppBar
                className={classes.appBar}
                position="static"
                style={{ backgroundColor: "white" }}
                elevation={0}>
                <Toolbar>
                    <Typography
                        className={classes.flex}
                        type="title"
                        color="inherit">
                        {title}
                    </Typography>
                    <Tooltip
                        title={t(
                            "correctionToolbar.Clear formatting on selection"
                        )}>
                        <IconButton
                            onClick={onRevertSelection}
                            className={classes.button}
                            aria-label={t(
                                "correctionToolbar.Clear formatting on selection"
                            )}>
                            <FormatClearIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={t("correctionToolbar.Undo")}>
                        <IconButton
                            onClick={onUndo}
                            className={classes.button}
                            aria-label={t("correctionToolbar.Undo")}>
                            <UndoIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={t("correctionToolbar.Redo")}>
                        <IconButton
                            onClick={onRedo}
                            className={classes.button}
                            aria-label={t("correctionToolbar.Redo")}>
                            <RedoIcon />
                        </IconButton>
                    </Tooltip>
                </Toolbar>
            </AppBar>
        );
    }
}

export default withStylesAndTranslation(CorrectionToolbar, styleSheet);



// WEBPACK FOOTER //
// ./src/components/CorrectionToolbar.jsx